export enum Right {
    Admin = 'Admin'
}
